(function ($) {
    $.nette.ext('show-password', {
        init() {
            const self = this;

            this.ext('snippets', true).after($.proxy(($el) => {
                $el.find('[type="password"].js-password-show').each(function () {
                    self.show($(this));
                });
            }, this));

            $('[type="password"].js-password-show').each(function () {
                self.show($(this));
            });
        },
    }, {
        show($el) {
            const $iconEyeOpen = $('.js-eye-open');
            const $iconEyeClosed = $('.js-eye-closed');

            $('.js-show-password-toggle').on('click', () => {
                if ($el.attr('type') === 'password') {
                    $el.attr('type', 'text');
                    $iconEyeOpen.hide();
                    $iconEyeClosed.show();
                } else {
                    $el.attr('type', 'password');
                    $iconEyeOpen.show();
                    $iconEyeClosed.hide();
                }
            });
        },
    });
}(jQuery));
